import moment from "moment";
import { momentLocalizer } from "react-big-calendar";
// Moment JS Docs
// Formats: https://momentjscom.readthedocs.io/en/latest/moment/04-displaying/01-format/

const unitsOfTime = [
    { value: "", label: "Select..." },
    { value: "m", label: "Minutes" },
    { value: "h", label: "Hours" },
    { value: "d", label: "Days" },
    { value: "w", label: "Weeks" },
    { value: "mo", label: "Months" },
    { value: "y", label: "Years" },
];

export const getUnitsOfTime = (all, delimitedValues) => {
    return all
        ? unitsOfTime
        : unitsOfTime.filter((x) =>
              String(delimitedValues)
                  .split(",")
                  .map((x) => x.trim())
                  .includes(x.value)
          );
};

export const getCalendarLocalizer = () => momentLocalizer(moment);

export const now = () => moment().toDate();

export const isDate = (date) => moment.isDate(date);

export const getDateMillis = (date) => {
    if (date) {
        if (date instanceof Date) {
            return date.getTime();
        }
        return date;
    }
    return null;
};

export const isDateString = (stringToCompare) => {
    var regex = /^(?:(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)[0-9]{2})$/;
    return regex.test(stringToCompare);
};

// Returns the equivalent unitOfTime in the moment library notation.
// The parameter unitOfTime should be a value of unitsOfTime[].
const parseUnitOfTimeToMomentNotation = (unitOfTime) => {
    if (!unitOfTime) {
        return null;
    }

    if (unitOfTime === "mo") {
        return "month";
    }

    return unitOfTime;
};

export const isDateValid = (date) => Boolean(date) && moment(date).isValid();

export const dateTimeAdd = (date, interval, unitOfTime) => {
    return isDateValid(date) ? moment(date).add(interval, parseUnitOfTimeToMomentNotation(unitOfTime)) : null;
};

// Eg: 8:01
export const timeToString = (dateTime) => {
    if (isDateValid(dateTime)) {
        return moment(dateTime).format("H:mm");
    }
    return "";
};

// Eg: 01/01/2024 8:01
export const dateToString = (date, includeTime = true) => {
    if (isDateValid(date)) {
        return moment(date).format("MM/DD/YYYY" + (includeTime ? " H:mm" : ""));
    }
    return "";
};

// Eg: Wednesday, December 11th 2024 8:30 PM
export const dateToFullString = (date) => {
    if (isDateValid(date)) {
        return moment(date).format("dddd, MMMM Do YYYY LT");
    }
    return "";
};

// Eg: January February ... November December
export const dateToMonthName = (date) => {
    if (isDateValid(date)) {
        return moment(date).format("MMMM");
    }
    return "";
};

// Eg: 1st 2nd ... 30th 31st
export const dateToDayOfMonth = (date) => {
    if (isDateValid(date)) {
        return moment(date).format("Do");
    }
    return "";
};

// Eg: 01 02 ... 30 31
export const dateToDayOfMonthNumber = (date) => {
    if (isDateValid(date)) {
        return moment(date).format("DD");
    }
    return "";
};

// Eg: Sunday Monday ... Friday Saturday
export const dateToDayOfWeekName = (date) => {
    if (isDateValid(date)) {
        return moment(date).format("dddd");
    }
    return "";
};

// Eg: Sun Mon ... Fri Sat
export const dateToDayOfWeekShortName = (date) => {
    if (isDateValid(date)) {
        return moment(date).format("ddd");
    }
    return "";
};

// unitOfTime = one of (day, week, month, year, etc...)
export const dateStart = (date, unitOfTime) => {
    return moment(date).startOf(unitOfTime);
};

// unitOfTime = one of (day, week, month, year, etc...)
export const dateEnd = (date, unitOfTime) => {
    return moment(date).endOf(unitOfTime);
};

export const isSameDate = (date1, date2, unitOfTime) => {
    if (date1 && date2) {
        return moment(date1).isSame(moment(date2), unitOfTime);
    }
    return false;
};

export const isToday = (date) => {
    return date ? isSameDate(date, moment(), "day") : false;
};

// Eg: 2024
export const getDateYear = (date) => moment(date).year();

// Returns a zero-based number of month.
// Eg: 0 = January | 11 = December
export const getDateMonth = (date) => moment(date).month();

// Eg: 1 ... 31
export const getDateDay = (date) => moment(date).date();

// Eg: 0 ... 23
export const getDateHour = (date) => moment(date).hour();

// Eg: 0 ... 59
export const getDateMinute = (date) => moment(date).minute();

// Eg: 
/* 
Last week           Last Monday at 2:30 AM
The day before	    Yesterday at 2:30 AM
The same day	    Today at 2:30 AM
The next day	    Tomorrow at 2:30 AM
The next week	    Sunday at 2:30 AM
Everything else	    7/10/2011
*/
export const getTodayRelativeDate = (date) => {
    return isDateValid(date) ? moment(date).calendar() : "";
}